<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Customers from '@/services/Customers';
    import DatePicker from "vue2-datepicker";
    import ModalViewEmailEvent from "@/components/modals/customers/modalViewEmailEvent";

    export default {
        components: {Layout, PageHeader, DatePicker, ModalViewEmailEvent},
        page: {
            title: "Emails",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                title: "Emails",
                items: [
                    {
                        text: "Users",
                    },
                    {
                        text: "Emails",
                        active: true,
                        href: "/customers/emails",
                    },
                ],
                csrf_token: localStorage.getItem('csrf_token'),
                isBusy: false,
                error: null,
                showModal: false,
                tableData: [],
                totalRows: 0,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "event_datetime",
                sortDesc: true,
                filterPeriod: '1d',
                daterange: "",
                recipient: "",
                eventData: [],
                emailEventTroubleshootSeries: [1],
                emailEventChartSeries: [
                    { name: "Open", data: [] },
                    { name: "Send", data: [] },
                    { name: "Delivery", data: [] },
                    { name: "Click", data: [] },
                ],
                loaderCountEmails:false,
                emailsCountSeries: [
                    {
                        name: "Emails",
                        type: "bar",
                        data: [],
                    },
                ],
                emailCountChartOptions: {
                    chart: {
                        width: "100%",
                        height: 320,
                        type: "bar",
                        stacked: false,
                        toolbar: {
                            show: true,
                        },
                    },
                    noData: {
                        text: 'No data available',
                        align: 'center',
                        verticalAlign: 'middle',
                        style: {
                            color: '#6c757d',
                            fontSize: '16px',
                        },
                    },
                    stroke: {
                        width: [1, 5],
                        curve: "smooth",
                    },
                    plotOptions: {
                        bar: {
                            columnWidth: "50%",
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    fill: {
                        opacity: [0.85, 1],
                        gradient: {
                            inverseColors: false,
                            shade: "light",
                            type: "vertical",
                            opacityFrom: 0.85,
                            opacityTo: 0.55,
                            stops: [0, 100, 100, 100],
                        },
                    },
                    colors: ["#5b73e8", "#f1b54d"],
                    markers: {
                        size: 0,
                    },
                    xaxis: {
                        labels: {
                            style: {
                                fontSize: '10px',
                                fontFamily: 'Helvetica, Arial, sans-serif',
                                fontWeight: 400,
                                cssClass: 'apexcharts-xaxis-label',
                            }
                        },
                        type: "text",
                    },
                    yaxis: {
                        title: {
                            text: "",
                        },
                    },
                    tooltip: {
                        shared: true,
                        intersect: false,
                        y: {
                            formatter: function(y) {
                                if (typeof y !== "undefined") {
                                    return y.toFixed(0) + "";
                                }
                                return y;
                            },
                        },
                    },
                },
                emailEventChartOptions: {
                    chart: {
                        width: "100%",
                        height: 320,
                        type: "bar",
                        stacked: false,
                        toolbar: { show: true },
                    },
                    noData: {
                        text: 'No data available',
                        align: 'center',
                        verticalAlign: 'middle',
                        style: { color: '#6c757d', fontSize: '16px' },
                    },
                    plotOptions: { bar: { columnWidth: "50%" } },
                    dataLabels: { enabled: false },
                    colors: ["#5b73e8", "#f1b54d", "#34c38f", "#f46a6a", "#9b59b6", "#1abc9c", "#e67e22", "#34495e"],
                    xaxis: { categories: [], labels: { style: { fontSize:'10px', fontFamily:'Helvetica, Arial, sans-serif', fontWeight:400, cssClass:'apexcharts-xaxis-label' } } },
                    yaxis: { title: { text: "Event Counts" } },
                    tooltip: {
                        shared: true,
                        intersect: false,
                        y: { formatter: y => (typeof y !== "undefined" ? y.toFixed(0) : y) },
                    },
                },

                emailEventTroubleshootOptions: {
                    chart: {
                        type: "pie",
                        height: 320,
                        toolbar: { show: true },
                    },
                    noData: {
                        text: 'No data available',
                        align: 'center',
                        verticalAlign: 'middle',
                        style: { color: '#6c757d', fontSize: '16px' },
                    },
                    labels: ["No data"], // initial dummy label
                    colors: ["#5b73e8", "#f1b54d", "#34c38f", "#f46a6a", "#9b59b6", "#1abc9c", "#e67e22", "#34495e"],
                    legend: { position: "bottom" },
                    dataLabels: {
                        enabled: true,
                        formatter: function (val, opts) {
                            return opts.w.globals.labels[opts.seriesIndex] + ": " + val.toFixed(2) + "%";
                        },
                    },
                    tooltip: {
                        y: { formatter: function (val) { return val; } },
                    },
                },

                periodOptions: [
                    {
                        text: "Last 24H",
                        value: "1d",
                    },
                    {
                        text: "Last 7 Days",
                        value: "7d",
                    },
                    {
                        text: "Last 30 Days",
                        value: "30d",
                    },
                    {
                        text: "Last 6 Months",
                        value: "6m",
                    },
                    {
                        text: "Last 12 Months",
                        value: "12m",
                    },
                ],
                tableFields: [
                    {
                        key: "messageId",
                        label: "Message ID",
                        sortable: true,
                    },
                    {
                        key: "from",
                        label: "From",
                        sortable: true,
                    },
                    {
                        key: "to",
                        label: "To",
                        sortable: true,
                    },
                    {
                        key: "subject",
                        label: "Subject",
                        sortable: false,
                    },
                    {
                        key: "email_type",
                        label: "Email Type",
                        sortable: false,
                    },
                    {
                        key: "eventType",
                        label: "Event Type",
                        sortable: true,
                    },
                    {
                        key: "eventTypeDetail",
                        label: "Event Type Detail",
                        sortable: true,
                    },
                    {
                        key: "recipient_isp",
                        label: "Recipient ISP",
                        sortable: false,
                    },
                    {
                      key: "event_datetime",
                      label: "Event Datetime",
                      sortable: true,
                    },
                    "Action"
                ]
            };
        },
        computed:{
            selectedPeriodText() {
                const found = this.periodOptions.find(p => p.value === this.filterPeriod);
                return found ? found.text : '';
            }
        },
        created() {
            this.getEmailsStats({ period: this.filterPeriod });
        },
        watch: {
            filterPeriod(newVal) {
                if (newVal) {
                    this.daterange = null;
                    this.recipient = '';
                    this.getEmailsStats({ period: newVal });
                }
            },

            daterange(newVal) {
                if (newVal) {
                    this.filterPeriod = null;
                    this.recipient = '';
                    this.getEmailsStats({
                        start_from: newVal[0],
                        start_to: newVal[1]
                    });
                }
            }
        },
        methods: {

            // Recipient search (button click or Enter)
            searchRecipient() {
                if (this.recipient) {
                    this.filterPeriod = null;
                    this.daterange = null;
                    this.getEmailsStats({ recipient: this.recipient });
                }
            },

            async getEmailsStats(filters = {}) {
                try {
                    this.toggleBusy();
                    this.loaderCountEmails = true;

                    // Build query params
                    const params = new URLSearchParams(filters).toString();
                    const response = await Customers.getEmailsStats(params);

                    const emails = response.data.data.emails || [];
                    const emailCounts = response.data.data.counts || {};       // unique emails per date
                    const eventCounts = response.data.data.event_counts || {}; // all events per date
                    const troubleshootCounts = response.data.data.troubleshoot_counts || {}; // troubleshoot totals

                    // Table data
                    this.tableData = emails;
                    this.totalRows = emails.length;

                    // Build charts safely
                    this.buildEmailChart(emailCounts);
                    this.buildEventChart(eventCounts);
                    this.buildTroubleshootEventChart(troubleshootCounts);

                } catch (error) {
                    this.error = error.response?.data?.error || "";
                    this.tableData = [];
                    this.totalRows = 0;

                    this.buildEmailChart({});
                    this.buildEventChart({});
                    this.buildTroubleshootEventChart({});
                } finally {
                    this.toggleBusy();
                    this.loaderCountEmails = false;
                }
            },

            buildEmailChart(emailCounts) {
                // Ensure emailCounts is an object
                emailCounts = emailCounts || {};

                // Get sorted dates
                const dates = Object.keys(emailCounts).sort();

                // Map values safely, defaulting to 0
                const values = dates.map(date => {
                    const val = emailCounts[date];
                    return typeof val === "number" ? val : 0;
                });

                // Update chart series
                this.emailsCountSeries = [
                    {
                        name: "Emails",
                        type: "bar",
                        data: values
                    }
                ];

                // Update chart categories (x-axis) safely
                this.emailCountChartOptions = {
                    ...this.emailCountChartOptions,
                    xaxis: {
                        ...this.emailCountChartOptions.xaxis,
                        categories: dates.length ? dates : ["No data"] // fallback if empty
                    }
                };
            },

            buildEventChart(eventCounts) {
                // Ensure eventCounts is an object
                eventCounts = eventCounts || {};

                // Get sorted dates (categories)
                const categories = Object.keys(eventCounts).sort();

                // Get all unique event types across all dates
                const eventTypes = Array.from(
                    new Set(categories.flatMap(date => Object.keys(eventCounts[date] || {})))
                );

                // Build series safely
                const series = eventTypes.map(eventType => ({
                    name: eventType,
                    data: categories.map(date => {
                        const value = eventCounts[date]?.[eventType];
                        return typeof value === "number" ? value : 0; // default to 0 if undefined
                    }),
                }));

                // Assign series and categories to chart
                this.emailEventChartSeries = series;
                this.emailEventChartOptions = {
                    ...this.emailEventChartOptions,
                    xaxis: {
                        ...this.emailEventChartOptions.xaxis,
                        categories: categories.length ? categories : ["No data"], // fallback
                    },
                };
            },

            buildTroubleshootEventChart(troubleshootCounts) {
                if (!troubleshootCounts || Object.keys(troubleshootCounts).length === 0) {
                    // No data: reset chart
                    this.emailEventTroubleshootSeries = [];
                    this.emailEventTroubleshootOptions.labels = [];
                    return;
                }

                // Extract labels and values
                const labels = Object.keys(troubleshootCounts || {}); // ['Bounce', 'DeliveryDelay']
                const series = labels.map(label => troubleshootCounts[label] || 0);

                this.emailEventTroubleshootSeries = series.length ? series : []
                this.emailEventTroubleshootOptions.labels = labels
            },

            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },

            viewEventDetails(item){
              this.eventData = item;
              this.$bvModal.show("view_event_details");
            }
        },
        middleware: "authentication",
    };
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">

                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-5">
                                <label>Last X Period</label>
                                <br />
                                <b-form-radio-group
                                        class="custom-check"
                                        id="btn-email-filter-time"
                                        button-variant="light"
                                        v-model="filterPeriod"
                                        :options="periodOptions"
                                        buttons
                                        name="radios-btn-default"
                                ></b-form-radio-group>
                            </div>
                            <div class="col-3">
                                <div class="form-group mb-3">
                                    <label>Date Range</label>
                                    <br />
                                    <date-picker
                                            v-model="daterange"
                                            range
                                            append-to-body
                                            lang="en"
                                            confirm
                                    ></date-picker>
                                </div>
                            </div>
                            <div class="col-3">
                                <b-form-group
                                        label="Recipient Email Address"
                                        label-for="formrow-recipient-input"
                                        class="mb-3"
                                >
                                    <b-input-group>
                                        <b-form-input
                                                v-model.trim="recipient"
                                                type="text"
                                                id="recipient"
                                                aria-describedby="recipient-feedback"
                                                placeholder="Enter recipient email"
                                        ></b-form-input>

                                        <b-input-group-append>
                                            <b-button variant="primary" @click="searchRecipient">
                                                Search
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-sm-4">
                                <span class="h5 ms-3 d-block d-md-inline">Email Count</span>
                                <apexchart
                                        v-if="!loaderCountEmails"
                                        id="emailsCountChart"
                                        data-colors='["--bs-primary", "#dfe2e6"]'
                                        class="apex-charts"
                                        ref="usersChart"
                                        :options="emailCountChartOptions"
                                        :series="emailsCountSeries"
                                >
                                </apexchart>
                                <div class="col-12 mt-5 d-flex align-items-center justify-content-center" v-else>
                                    <b-spinner large></b-spinner>
                                </div>
                            </div>


                            <div class="col-sm-5">
                                <span class="h5 ms-3 d-block d-md-inline">Email Event Count</span>
                                <apexchart
                                        v-if="!loaderCountEmails"
                                        class="apex-charts"
                                        height="350"
                                        type="bar"
                                        dir="ltr"
                                        :series="emailEventChartSeries"
                                        :options="emailEventChartOptions"
                                ></apexchart>
                                <div class="col-12 mt-5 d-flex align-items-center justify-content-center" v-else>
                                    <b-spinner large></b-spinner>
                                </div>
                            </div>

                            <div class="col-sm-3">
                                <span class="h5 ms-3 d-block d-md-inline">Delivery Failures Event Count</span>
                                <apexchart
                                        v-if="!loaderCountEmails"
                                        class="apex-charts"
                                        height="320"
                                        type="pie"
                                        dir="ltr"
                                        :series="emailEventTroubleshootSeries"
                                        :options="emailEventTroubleshootOptions"
                                ></apexchart>
                                <div class="col-12 mt-5 d-flex align-items-center justify-content-center" v-else>
                                    <b-spinner large></b-spinner>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <h5 class="mt-2">Email Event Entries</h5>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="mb-0">
                            <b-table
                                    :busy="isBusy"
                                    :items="tableData"
                                    :fields="tableFields"
                                    responsive
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    show-empty
                                    empty-text="No Data Found"
                                    @filtered="onFiltered"
                            >

                              <template v-slot:cell(action)="data">
                                <ul class="list-inline mb-0">
                                  <li class="list-inline-item">
                                    <a href="javascript:void(0);" class="px-2 text-primary"
                                       title="View Event Details" @click="viewEventDetails(data.item)">
                                      <i class="uil uil-eye font-size-18"></i>
                                    </a>
                                  </li>
                                </ul>
                              </template>

                              <template #table-busy>
                                  <div class="text-center text-danger my-2">
                                      <b-spinner class="align-middle"></b-spinner>
                                      <strong>Loading...</strong>
                                  </div>
                              </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

      <ModalViewEmailEvent :eventData="eventData"></ModalViewEmailEvent>
    </Layout>
</template>